import styled from '@emotion/styled';
import { Magnetic as Mi } from "../../styles";
export const StyledProgressBar = styled.div `
	display: block;
	background-color: ${Mi.colorNeutral30};
`;
export const StyledProgressDiv = styled.div `
	display: flex;
`;
export const StyledThresholdIndicatorDiv = styled.div `
	justify-content: flex-end;
	z-index: 4;
`;
export const StyledProgressPercentage = styled('div', {
    shouldForwardProp: prop => prop !== 'progressPercentageColor'
})((props) => `color: ${props.progressPercentageColor};
	font-size: ${Mi.fontSize10};
	font-weight: ${Mi.fontWeightHeavy};
	margin: auto;
`);
//# sourceMappingURL=styles.js.map